import { useTranslation } from 'react-i18next'

import { useLinkLikeClick } from '../../../hooks'
import Button from '../../Button'

import * as styles from './RentalPortalProfilePreviewOpenButton.module.css'

import ArrowRightIcon from '../../../icons/chevrons/right.svg'

function RentalPortalProfilePreviewOpenButton({ link, qaName }) {
  const { t } = useTranslation()

  const { handleClick: handleLinkClick } = useLinkLikeClick()

  function handleClick(event) {
    handleLinkClick({ event, link })
  }

  return (
    <div className={styles.RentalPortalProfilePreviewOpenButton}>
      <Button.Contained
        afterIconProps={{ Icon: ArrowRightIcon }}
        qaName={qaName}
        text={t('RentalPortal.ApplicantPreviewOpenProfileBtnKey')}
        onClick={handleClick}
      />
    </div>
  )
}

export default RentalPortalProfilePreviewOpenButton
